document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".pricing-cards__switch").forEach((toggle) => {
    const section = toggle.closest(".pricing-cards");
    if (!section) return;

    const labelMonthly = section.querySelector(
      ".pricing-cards__toggle-label--monthly",
    );
    const labelAnnual = section.querySelector(
      ".pricing-cards__toggle-label--annual",
    );

    toggle.addEventListener("click", () => {
      const isAnnual = toggle.getAttribute("aria-checked") === "true";
      const newState = !isAnnual;

      toggle.setAttribute("aria-checked", String(newState));
      section.classList.toggle("pricing-cards--annual", newState);

      if (labelMonthly) labelMonthly.dataset.active = String(!newState);
      if (labelAnnual) labelAnnual.dataset.active = String(newState);
    });
  });
});
